import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_koltai from "../../assets/img/face_tamas_koltai.jpg";
import ShowMoreText from "react-show-more-text";
import proj_DEA_in_engineering from "../../assets/img/proj_DEA_in_engineering.png";

const Tamas_Koltai_DEA = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_DEA_in_engineering} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_koltai}
            />{" "}
            <p className="text7">Tamás Koltai</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">Department of Management and Business Economics, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            
            Efficient utilization of the diverse set of resources applied in organizations for 
            production, service and public administration processes is a primary objective. This 
            objective can only be achieved if the best practices are identified, and improvement 
            possibilities are explored for the inefficient units. Based on the input (applied resources) 
            and output (achieved objectives) information of organizations, Data Envelopment Analysis 
            (DEA) can support benchmarking and efficiency improvement decisions. With the help of DEA, 
            the efficiency of decision-making units can be evaluated based on their ratio of weighted 
            inputs and weighted outputs. As a result of the calculation the set of benchmarking 
            organizations is identified, and the efficiency frontier is determined. The distance of 
            inefficient units from the efficiency frontier helps to identify several improvement strategies.
            <br />

            The application area of DEA is exponentially increasing in the field of economics and 
            management. Several models are developed to capture the most important conditions of 
            real-life decision-making environment including nonfinancial indicators of operation 
            and sustainability related conditions.
            <br />
            The objective of this research is to evaluate reinforced concrete beam variants 
            considering jointly engineering and sustainability related parameters.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Tamas_Koltai_DEA;